// extracted by mini-css-extract-plugin
export default {"background":"ForgotPW_background__lB6rz","plane":"ForgotPW_plane__Dld64","fly":"ForgotPW_fly__vW30L","icon":"ForgotPW_icon__0VgOV"};